module.exports = __webpack_public_path__ + "img/logo-contract.1d53d3e5.svg";